import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { EnsureAuthenticated } from '../../services/ensure-authenticated.service';
import { LoginRedirect } from '../../services/login-redirect.service';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [EnsureAuthenticated] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    EnsureAuthenticated,
    LoginRedirect
  ]
})
export class HomeRoutingModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/home/home-routing.module.ts